export const navigation = {
tabs: {
home: "الرئيسية",
assets: "الأصول",
work: "العمل",
reports: "التقارير",
contacts: "جهات الاتصال",
analytics: "الرؤى",
account: "الحساب",
},
planLapsed: {
member: "لم تعد خطة مساحة العمل هذه تتضمن الفرق. يمكنك قراءة كل شيء دون تغييره — اطلب من مالك مساحة العمل استعادة الخطة.",
},
mobile: {
moreTab: "المزيد",
scanTab: "مسح",
moreSubtitle: "المزيد من مساحة عملك والاختصارات.",
planLockedA11y: "{{label}}، غير مضمَّن في خطتك. يفتح الخطط التي تشمله.",
overflowSection: "اختصارات",
overflow: {
  sites: "المواقع",
contacts: "جهات الاتصال",
reports: "التقارير",
analytics: "الرؤى",
knowledge: "قاعدة المعرفة",
guide: "المساعدة",
assistant: "المساعد",
activity: "النشاط",
calendar: "التقويم",
checklists: "قوائم التحقق",
groupRules: "قواعد المجموعات",
compliance: "الامتثال",
inspections: "التفتيش",
jobs: "المهام",
people: "الأشخاص",
profile: "الملف الشخصي",
},
},
stack: {
forgotPassword: "نسيت كلمة المرور",
setNewPassword: "كلمة مرور جديدة",
newAsset: "أصل جديد",
editAsset: "تعديل الأصل",
addDocument: "إضافة مستند",
renewDocument: "تجديد المستند",
newChecklist: "قائمة تحقق جديدة",
newInspection: "تفتيش جديد",
shareReport: "إرسال التقرير",
convertToJobs: "تحويل إلى مهام",
inspectionReview: "مراجعة التفتيش",
contractors: "المقاولون",
contractorHome: "صفحة المقاول",
scheduleInspection: "جدولة تفتيش",
scheduleDetails: "تفاصيل الجدولة",
calendar: "التقويم",
teamManagement: "إدارة الفريق",
teamInvitation: "دعوة الفريق",
workspaceAiAudit: "تدقيق الذكاء الاصطناعي والأتمتة",
workspaceBilling: "الفوترة والاستخدام",
contactInvitation: "دعوة جهة اتصال",
asset: "أصل",
submitQuote: "إرسال عرض سعر",
inviteOnly: "بالدعوة فقط",
privateRequest: "طلب خاص",
quoteRequest: "طلب عرض سعر",
inspectionReport: "تقرير الفحص",
checklist: "قائمة التحقق",
quotes: "عروض الأسعار",
jobsCreated: "المهام المُنشأة",
reviewContact: "مراجعة جهة الاتصال",
reviewContactSub: "تعديل وإضافة أدوار",
inspectionComplete: "اكتمل الفحص",
requestQuotes: "طلب عروض أسعار",
generateWithAI: "توليد بالذكاء الاصطناعي",
generateWithAISub: "اقتراح مسودة قائمة تحقق",
generationFailed: "فشل التوليد",
reviewAssign: "مراجعة وتعيين",
reviewAssignListSub_one: "أمر عمل واحد · حدد مسار العمل وعيّن",
reviewAssignListSub_other: "{{count}} أمر عمل · حدد مسار العمل وعيّن",
importContacts: "استيراد جهات الاتصال",
importContactsSub: "كيف تريد إضافتها؟",
phonePicker: "منتقي الهاتف",
phonePickerSub: "جهة اتصال واحدة لكل اختيار",
suggestedJobs: "مهام المتابعة",
saveWorkflowTemplate: "حفظ قائمة تحقق سير العمل",
sentForApproval: "أُرسل للموافقة",
assetReadOnlyShared: "للقراءة فقط · مُشارك معك",
analytics: "الرؤى",
analyticsScope: "النطاق: {{label}}",
scheduledInspection: "فحص مجدول",
scheduleFallback: "الجدولة",
sharedKnowledge: "معرفة مُشاركة",
settings: "الإعدادات",
help: "المساعدة",
preferences: "التفضيلات",
deleteAccount: "حذف الحساب",
contact: "جهة اتصال",
addContact: "إضافة جهة اتصال",
editContact: "تعديل جهة اتصال",
contractorDirectory: "دليل المقاولين",
importFromContacts: "استيراد من جهات الاتصال",
addContractor: "إضافة مقاول",
alreadyExists: "موجود مسبقًا",
updateContractor: "تحديث المقاول",
inspection: "تفتيش",
job: "مهمة",
convertToJobsApproved_zero: "{{count}} معتمد",
convertToJobsApproved_one: "{{count}} معتمد",
convertToJobsApproved_two: "{{count}} معتمد",
convertToJobsApproved_few: "{{count}} معتمد",
convertToJobsApproved_many: "{{count}} معتمد",
convertToJobsApproved_other: "{{count}} معتمد",
reviewAssignListSub_zero: "لا أوامر عمل · حدد مسار العمل وعيّن",
reviewAssignListSub_two: "أمرا عمل · حدد مسار العمل وعيّن",
reviewAssignListSub_few: "{{count}} أوامر عمل · حدد مسار العمل وعيّن",
reviewAssignListSub_many: "{{count}} أمر عمل · حدد مسار العمل وعيّن",
recurringJobCreate: "خطة صيانة جديدة",
},
scopeChip: {
all: "الكل",
personal: "شخصي",
teamNamed: "الفريق: {{name}}",
teamFallback: "فريق",
modalTitle: "النطاق",
cancel: "إلغاء",
a11y: "مرشح مساحة العمل، {{label}}",
},
shell: {
brandTitle: "AssetWRX",
brandSubtitle: "منصة عمليات الأصول",
navSection: "التنقل",
sectionOperate: "التشغيل",
sectionNetwork: "الشبكة",
sectionInsights: "الرؤى",
sectionAccount: "الحساب",
brandHomeA11y: "الرئيسية AssetWRX",
brandHomeWithWorkspaceA11y: "{{workspace}} · الصفحة الرئيسية لـ AssetWRX",
collapseNav: "طي التنقل",
expandNav: "توسيع التنقل",
primaryNavA11y: "التنقل الرئيسي",
accountA11y: "الحساب",
notificationsA11y: "الإشعارات",
skipToContent: "تخطَّ إلى المحتوى الرئيسي",
notificationsA11yUnread_zero: "الإشعارات، {{count}} غير مقروءة",
notificationsA11yUnread_one: "الإشعارات، {{count}} غير مقروءة",
notificationsA11yUnread_two: "الإشعارات، {{count}} غير مقروءة",
notificationsA11yUnread_few: "الإشعارات، {{count}} غير مقروءة",
notificationsA11yUnread_many: "الإشعارات، {{count}} غير مقروءة",
notificationsA11yUnread_other: "الإشعارات، {{count}} غير مقروءة",
notificationsA11yUnreadMany: "الإشعارات، أكثر من 99 غير مقروءة",
activitySheetTitle: "الإشعارات",
activityUnreadSubtitle_zero: "{{count}} غير مقروءة",
activityUnreadSubtitle_one: "{{count}} غير مقروءة",
activityUnreadSubtitle_two: "{{count}} غير مقروءة",
activityUnreadSubtitle_few: "{{count}} غير مقروءة",
activityUnreadSubtitle_many: "{{count}} غير مقروءة",
activityUnreadSubtitle_other: "{{count}} غير مقروءة",
activityUnreadSubtitleCapped: "أكثر من {{limit}} غير مقروءة",
activityEmpty: "لا إشعارات بعد",
activitySeeAll: "كل النشاط",
accountRailA11y: "أقسام الإعدادات",
accountRailTitle: "الإعدادات",
accountRailSubtitle: "الحساب الشخصي ومساحة العمل والإدارة",
sectionPersonal: "أنت",
sectionWorkspace: "مساحة العمل",
sectionTeam: "الفريق",
sectionAdmin: "الإدارة",
accountNavProfile: "الملف الشخصي",
accountNavPersonalDetails: "تفاصيل الملف",
accountNavPreferences: "التفضيلات",
accountNavHelp: "المساعدة",
accountNavWorkspaceOverview: "نظرة عامة",
accountNavDefaults: "الافتراضيات",
accountNavOrganization: "المؤسسة",
accountNavBranding: "هوية التقارير",
accountNavTeam: "الفريق والدعوات",
accountNavBilling: "الفوترة والاستخدام",
accountNavIntegrations: "التكاملات",
accountNavSyncCenter: "تغييرات لم تُرسل",
accountNavApiExplorer: "مستكشف API",
accountNavAudit: "تدقيق الذكاء الاصطناعي والأتمتة",
accountNavTemplates: "قوائم التحقق",
accountNavFeatures: "الميزات",
accountNavDiagnostics: "التشخيص",
accountNavAbout: "حول",
accountNavIndustryPacks: "حزم القطاعات",
accountNavAssetTypes: "أنواع الأصول",
accountNavAi: "تدقيق استخدام الذكاء الاصطناعي",
accountNavAssistantActivity: "نشاط المساعد",
accountNavPrivacy: "الخصوصية",
accountNavBillingShort: "الفوترة",
accountNavTeams: "الفرق",
accountNavSecurity: "الأمان",
accountNavNotifications: "الإشعارات",
accountNavBrandingDefaults: "الهوية والافتراضيات",
accountNavHandbook: "دليل التكامل",
sectionAdvanced: "متقدم",
railBackToSettings: "جميع الإعدادات",
railAssistant: "المساعد",
railIntegrations: "الأتمتة",
railBilling: "الفوترة",
},
  // The header trail on detail screens: Site › Asset › work item › Report.
  trail: {
    sites: 'المواقع',
    site: 'الموقع',
    assets: 'الأصول',
    asset: 'الأصل',
    inspection: 'الفحص',
    job: 'المهمة',
    report: 'التقرير',
    plan: 'الخطة',
    document: 'المستند',
    contacts: 'جهات الاتصال',
    contact: 'جهة الاتصال',
  },
};
